import { styled } from '@fctg-ds/theme';

export const Flex = styled('div', {
  shouldForwardProp: (prop) => prop !== 'column' && prop !== 'sx',
})<{ column?: boolean }>(({ column }) => ({
  flex: 1,
  display: 'flex',
  flexDirection: column ? 'column' : 'row',
}));
